import {
  faArrowDownWideShort,
  faArrowsFromDottedLine,
  faArrowUpWideShort,
  faCheckDouble,
  faRotate,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { TaskType } from '@/types/assistant';

export const AI_TEXT_ACTIONS: {
  key: string;
  label: string;
  icon: IconDefinition;
  task: TaskType;
}[] = [
  {
    key: 'improve-writing',
    label: 'Improve writing',
    icon: faRotate,
    task: TaskType.REPHRASE,
  },
  {
    key: 'fix-grammar',
    label: 'Fix grammar',
    icon: faCheckDouble,
    task: TaskType.FIX_GRAMMAR,
  },
  {
    key: 'make-shorter',
    label: 'Make shorter',
    icon: faArrowDownWideShort,
    task: TaskType.SHORTEN,
  },
  {
    key: 'extend',
    label: 'Make longer',
    icon: faArrowUpWideShort,
    task: TaskType.EXTEND,
  },
  {
    key: 'continue-writing',
    label: 'Continue writing',
    icon: faArrowsFromDottedLine,
    task: TaskType.CONTINUE_WRITING,
  },
] as const;

export const AI_TOAST_MESSAGES = {
  NO_TEXT_SELECTED: 'Please select text first.',
  NO_PROMPT: 'Please enter a prompt.',
  NO_FOLLOW_UP_PROMPT: 'Please enter a follow-up prompt.',
  NO_CONTENT: 'No content to process.',
  CONTENT_REPLACED: 'Content replaced successfully.',
  CONTENT_INSERTED: 'Content inserted successfully.',
  GENERATION_FAILED: 'Failed to generate content.',
  RETRY_FAILED: 'Retry operation failed.',
  OPERATION_CANCELLED: 'Operation cancelled.',
  OPERATION_IN_PROGRESS: 'Please complete or cancel the current AI operation before continuing.',
} as const;
